import { ReactComponent as ViaCentralDark } from '@assets/images/Via/ViaCentralDark.svg';
import { Box, Stack, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { TenantThemeContext } from '../TenantThemeContextProvider';
import { useResponsive } from '@utils/useResponsive';

export const TenantBrandingHeader: React.FC = () => {
  const tenantContext = useContext(TenantThemeContext);  
  const logo = tenantContext.isBrandingEnabled ? tenantContext.squareLogoUrl ?? tenantContext.topBarLogoUrl : undefined;
  const { isMobile } = useResponsive();
  if (logo) {
    return (
      <Box>
        <img src={logo} alt="" height={isMobile ? 120 : 200} />
      </Box>
    );
  }

  const ViaCentralIcon = ViaCentralDark;

  return (
    <Stack alignItems="center" justifyContent="center" spacing={1.5}>
      <Box sx={{ '& svg': { height: 80, width: 'auto' } }}>
        <ViaCentralIcon />
      </Box>
      <Typography variant="h5" color="primary.main" textAlign="center">
        {tenantContext.name}
      </Typography>
    </Stack>
  );
};
